import { Modal as ModalNeetoUI } from "neetoui";

import Details from "./Details";

const Modal = ({ isOpen, onClose, movie }) => (
  <ModalNeetoUI isOpen={isOpen} size="large" onClose={onClose}>
    <div className="min-h-[400px] p-6">
      <Details movieId={movie?.imdbId} />
    </div>
  </ModalNeetoUI>
);

export default Modal;
